import { useQuery } from "react-query";
import { getAccountContacts } from "../services";

export const useAccountContacts = (accountNumber: string) => {
  return useQuery(["accounts/contacts", accountNumber], getAccountContacts, {
    enabled: !!accountNumber,
  });
};
